// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"fkmxLh","container":"RMZm6U"};